import { useState, useEffect } from 'react'
import { L10n, Locale } from '../../game/systems/LocalizationSystem'
import { GameBus } from '../../game/core/GameBus'

export function useL10n() {
  const [, setTick] = useState(0)

  useEffect(() => {
    const unsub = GameBus.on('locale:changed', () => {
      setTick(t => t + 1)
    })
    return () => { unsub() }
  }, [])

  return {
    t: (key: string) => L10n.t(key),
    locale: L10n.getLocale(),
    setLocale: (l: Locale) => L10n.setLocale(l)
  }
}
